/* eslint-disable react/no-array-index-key */
import React from 'react'
import { useStoreState } from 'easy-peasy'
import styled from 'styled-components'
import Transition from './Transition'

const Container = styled.div`
  padding-bottom: 0;
`

export default function Main() {
  const [pages] = useStoreState(state => [state.steps.pages])
  return (
    <Container>
      {pages.map(({ type }, index) => (
        <Transition key={`page-${index}`} step={index} type={type} />
      ))}
    </Container>
  )
}
